import React, { FC } from 'react';
import clsx from 'clsx';
import { isMobileChannel } from '../../common/util';

const NuiTitle: FC<{ title: string; otherClass?: string; center?: boolean }> = ({
    title,
    otherClass,
    center = false
}) => {
    const mobilePlatform = isMobileChannel();
    return (
        <h1
            className={clsx(
                otherClass,
                `uppercase f-condensed lh-1 italic px-20 py-20 pt-30 text-extra-bold c-black-100 m-0 ${
                    mobilePlatform ? 'fs-20' : 'fs-24'
                } ${center || mobilePlatform ? 'text-center' : 'text-left'}`
            )}
        >
            {title}
        </h1>
    );
};

export default NuiTitle;
